module.exports = __webpack_public_path__ + "static/img/18a.d4ad8d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/18a.jpg
// module id = diTb
// module chunks = 0